import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { WAITING_STEP_DEPENDENCIES_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_run_waiting_step_dependencies_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRunId from '@/hooks/useRunId.ts';
import { RuntimeScopeQuery, WaitingStepDependencies } from '@/types/stepExecutions.ts';
import { getRuntimeScopeQueryParams } from '@/utils/stepRunScope.ts';

const useWaitingStepDependencies = (
  scope: RuntimeScopeQuery | undefined,
  enabled: boolean,
): UseQueryResult<WaitingStepDependencies, AxiosError> => {
  const apiClient = useApiClient();
  const runId = useRunId();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: WAITING_STEP_DEPENDENCIES_KEY(automationId, runId, scope),
    queryFn: async () => {
      const response = await apiClient.get(get_run_waiting_step_dependencies_url(runId), {
        params: getRuntimeScopeQueryParams(scope),
      });
      return response.data;
    },
    enabled: !!runId && enabled,
  });
};

export default useWaitingStepDependencies;
